import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ProductCommonModule } from '../product-common.module';
import { FallBackImageService } from '../services/fallBack-images.service';

import { ProductDebugComponent } from './components/product-debug/product-debug.component';
import { ProductPromotionDatesComponent } from './components/product-promotion-dates/product-promotion-dates.component';
import { ProductSkeletonComponent } from './components/product-skeleton/product-skeleton.component';
import { ProductViewComponent } from './components/product-view/product-view.component';
import { ProductViewAddtocartComponent } from './components/product-view-addtocart/product-view-addtocart.component';
import { ProductViewDetailsComponent } from './components/product-view-details/product-view-details.component';
import { ProductViewMediaComponent } from './components/product-view-media/product-view-media.component';
import { ProductViewRelatedTagComponent } from './components/product-view-related-tag/product-view-related-tag.component';
import { ProductInViewDirective } from './directives/product-is-in-view.directive';

import { PlatformService } from '@core/services/platform/platform.service';
import { UiService } from '@core/services/ui.service';
import { UiMspotModule } from '@features/mspot/mspot.module';
import { ProductsArrayFeaturePublicApi } from '@features/productsArray';
import { WishlistFeatureUiModule } from '@features/wishlist/wishlist-feature-ui.module';
import { ProductPriceService } from '@shared/prices/services/product-prices.service';
import { ViewItemService } from '@shared/product/product-view/services/view-item.service';
import { UiSvgIconModule } from '@shared/ui/svg-icon/svg-icon.module';
import { DialogModule } from '@ui/dialog/dialog.module';

@NgModule({
    declarations: [
        ProductDebugComponent,
        ProductInViewDirective,
        ProductSkeletonComponent,
        ProductViewAddtocartComponent,
        ProductViewComponent,
        ProductViewDetailsComponent,
        ProductViewMediaComponent,
        ProductViewRelatedTagComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        DialogModule,
        FormsModule,
        ProductCommonModule,
        ProductPromotionDatesComponent,
        ReactiveFormsModule,
        UiMspotModule,
        UiSvgIconModule,
        WishlistFeatureUiModule,
    ],
    exports: [
        ProductSkeletonComponent,
        ProductViewComponent,
    ],
    providers: [
        FallBackImageService,
        PlatformService,
        ProductPriceService,
        ProductsArrayFeaturePublicApi,
        UiService,
        ViewItemService,
    ],
})
export class ProductViewModule { }
